<template>
  <div>

    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>

    <header-home-two @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"
                     :menuItems="navs"/>


    <section class="appie-testimonial-2-area mt-100 mb-90" id="testimonial">
      <div class="container maincard">
        <div class="row">
          <div class="col-lg-12">
            <center><span v-html="title" :style="{textSizeAdjust:textSize}"></span></center>
            <!--            <br>-->
            <div class="row">
              <div v-for="(templateData,index) in template" :key="index">
                <div v-if="templateData.template_13 && templateData.template_13.length > 0">
                  <div v-for="(item, itemIndex) in templateData.template_13" :key="itemIndex" class="mt-2">
                    <div class="card" style="width: 100%" :style="{backgroundColor:item.bgColor}">
                      <div class="card-body p-0">
                        <div class="" style="display: flex;">
                          <!--                        <div class="row" style="display: flex;">-->
                          <a @click="OpenProfile(item.activity,item.url,item.action,item.type)"
                             style="display: contents;">
                            <div class="col-2">
                              <img :src="item.image" style="height: 50px;">
                            </div>
                            <div class="col-8">
                              <p :style="{fontSize:item.textSize,textAlign:item.gravity,color:item.txt_color,padding:'10px'}">
                                {{ stripTags(item.title) }}</p>
                            </div>
                            <div class="col-2" style="padding: 6px">
                              <div v-if="item.btnVisible == '1'">
                                <button type="button" class="btn"
                                        :style="{border:item.borderColor,backgroundColor:item.btnColor,color:item.btntextColor,}">
                                  {{ item.btnText }}
                                </button>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue">
          <div class="row">
            <!-- First Card Row -->
            <div class="col-12 col-lg-12 col-md-12 mb-4" v-for="(customerCareData,index) in customerCare" :key="index">
              <span v-html="stripTags(customerCareData.label)"></span>


              <div class="card" style="background: antiquewhite;">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i class="fa fa-phone flipped" style="background: white;" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>


    <!--====== APPIE TESTIMONIAL 2 PART ENDS ======-->

    <!--====== APPIE SPONSER PART START ======-->

    <!--    <sponser-home-two title="Appie works best with" more_title="your favorite platforms" description="Join over 40,000 businesses worldwide."/>-->

    <!--====== APPIE SPONSER PART ENDS ======-->

    <!--====== APPIE FOOTER PART START ======-->

    <!--    <footer-home-two/>-->


    <!--====== APPIE FOOTER PART ENDS ======-->


    <!--====== APPIE BACK TO TOP PART ENDS ======-->
    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
import SidebarHomeOne from '../HomeOne/SidebarHomeOne.vue'

import HeaderHomeTwo from '../HomePage/Header.vue'

import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";

export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    HeaderHomeTwo,

    SidebarHomeOne,
  },
  data() {
    return {
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      title: '',
      textSize: '',
      countView: [],
      list: [],
      ListTitleData: [],
      ListButtonData: [],
      bgColor: '',
      template: '',
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            // {
            //   // name:'Home 5',
            //   name: 'Change Mobile Number',
            //   path: '/home-five'
            // },
            // {
            //   name:'Home 6',
            //   path:'/home-six'
            // },
            // {
            //   name:'Home 7',
            //   path:'/home-seven'
            // },
            // {
            //   name:'Home 8',
            //   path:'/home-eight'
            // },
          ],
        },
        // {
        //   name:'service',
        //   path:'/service-details'
        // },
        // {
        //   name:'pages',
        //   childrens:[
        //     {
        //       name:'About us',
        //       path:'/about-us'
        //     },
        //     {
        //       name:'Error',
        //       path:'/error'
        //     }
        //   ],
        // },
        // {
        //   name:'news',
        //   childrens:[
        //     {
        //       name:'News',
        //       path:'/news'
        //     },
        //     {
        //       name:'Single news',
        //       path:'/single-news'
        //     },
        //   ],
        // },
        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },
        // {
        //   // name:'contact',
        //   name:'Notification',
        //   path:'/notifi'
        // }
      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },
  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },

  async created() {
    if (this.$route.query.page) {
      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);
      this.modifiedString = decryptedString;
      try {
        const PaymentHistoryData = await callAxiosWithConfig(this.modifiedString, '', 'post');
        // console.log(PaymentHistoryData);
        // console.log(PaymentHistoryData.title);
        // this.title = PaymentHistoryData;
        this.title = PaymentHistoryData.title;
        this.template = PaymentHistoryData.template;
        // console.log(this.countView)
        this.list = PaymentHistoryData.list;

        this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
        this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
        this.customerCare = JSON.parse(localStorage.getItem("customerCare"));

        // console.log(this.SideMenu)
        this.$emit("tempData", this.SideMenu);
        this.$emit("title", this.titleWord);
        this.$emit("customerCare", this.customerCare);
        // this.template = otpdata.template;
        // console.log(this.template)
        // const inputString = otpdata;
        // this.$emit("tempData", this.title);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle 401 status silently
          // For example, do nothing or log a message without displaying it
        } else {
          // Handle other errors by displaying them
          console.error('Error in Axios request:', error);
        }

      }
      // alert(this.modifiedString);
      // alert(this.modifiedString);
      // this.EditId = this.$route.query.id;
      // this.decryptedValue = this.Decrypt(this.encryptedParam);
      // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    }
    // this.encryptedParam = this.$route.query.page;
    //
    // this.decryptedValue = this.Decrypt(this.encryptedParam);
    // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    // console.log(this.modifiedString)


  },

  methods: {
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    stripTags(html) {
      // Regular expression to remove HTML tags
      return html.replace(/<[^>]+>/g, '');
    },

    navigateToSamePage() {
      this.$router.go(-1);
    },

    Decrypt(str) {
      return str.replace(/[a-zA-Z]/g, function (char) {
        const charCode = char.charCodeAt(0);
        const decryptedCharCode = charCode - 1; // Decryption logic
        return String.fromCharCode(decryptedCharCode);
      });
    },

    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

    async OpenProfile(activity, url, action, type) {

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;

      if (lastPart === 'ViewCandidate_List') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
      }
      else if (lastPart === '') {
        if (action == 'url') {
          // alert(type)
          window.location.href = type
        }
      } else if (lastPart === 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }
    },

    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },
  }

}
</script>

<style>
.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .temp_10_space {
    margin-bottom: 30px;
  }

  .imageSize {
    width: 10%;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {

}

@media (min-width: 768px) and (max-width: 991px) {

}

/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }

  .imageSize {
    width: 4%;
  }
}

</style>
